import { StreamDashboardComponent } from './../../stream-dashboard/stream-dashboard.component';
import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AppdataService } from '../../../../service/appdata.service';
import { UserdataService } from '../../../../service/userdata.service';
import { SnackService } from '../../../../service/snack.service';
import { TrackService } from '../../../../service/track.service';

@Component({
  selector: 'app-streamoverview',
  standalone: false,

  templateUrl: './streamoverview.component.html',
  styleUrl: './streamoverview.component.scss'
})
export class StreamoverviewComponent {
  readonly dialogRef = inject(MatDialogRef<StreamoverviewComponent>);
  readonly dialog = inject(MatDialog);
  trackService = inject(TrackService);
  readonly data = inject<any>(MAT_DIALOG_DATA);
  category: any
  showLoading: boolean = false;

  constructor(
    private router: Router,
    private appData: AppdataService,
    private userData: UserdataService,
    private snack: SnackService
  ) {
    this.category = this.data.category;

    this.loadAllStepsForStream();
  }


  async loadAllStepsForStream() {
    this.category.tracks.forEach((track: any) => {
      track.streams.forEach(async (stream: any) => {
        stream.steps = await this.appData.loadStepsByStreamId(stream.id);
      });
    });
  }

  async startTrack(track: any) {
    let projectId = await this.userData.getDefaultProjectId();
    if (!projectId) {
      this.snack.error(
        { error: { msg: { headline: "No Project found", message: "Please contact the support team. There is no project in your accouunt." } } }
      );
      return;
    }
    let name = 'My ' + track.name;
    let currentStep = 'initial-' + track.streams[0].id


    this.showLoading = true;
    let result = await this.trackService.startTrack(track.id, track.streams[0].id, currentStep, projectId, name);
    this.showLoading = false;
    if (result === false) return;

    this.router.navigate(['track', track.id], {
      queryParams: {
        streamId: track.streams[0].id,
        stepId: currentStep,
        roundId: result
      }
    });
    this.dialogRef.close('newTrack');
  }

  close() {
    this.dialogRef.close('close');
  }
}
